// goodbye.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { VodafoneIconComponent } from '@app/shared/icons/vodafone.component';

@Component({
  standalone: true,
  selector: 'app-goodbye',
  imports: [
    CommonModule,
    VodafoneIconComponent,
  ],
  template: `
    <div class="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4 relative">

      <!-- Vodafone Logo centered -->
      <app-vodafone-icon class="mb-6 w-16 h-16 text-red-600"></app-vodafone-icon>

      <h1 class="text-3xl font-bold mb-4">Goodbye!</h1>

      <p class="text-gray-700 text-lg">
        You have been logged out. We hope to see you again soon!
      </p>

      <div class="mt-8">
        <button 
          (click)="goToLogin()"
          class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-vodafone-red hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-vodafone-red transition-colors"
        >
          Back to Login
        </button>
      </div>
    </div>
  `,
})
export class GoodbyeComponent {
  constructor(private router: Router) {}

  goToLogin(): void {
    this.router.navigate(['/question']);
  }
}
